<template>
  <div class="resume-candidate-detail" v-if="candidate">
    <div class="top-banner flex-box">
      <div class="img-wrap">
        <img v-if="candidate.gender == 2" :src="candidate.avatar.remoteUrl | avatar('women')" v-img-error-user="2" alt="" />
        <img v-else :src="candidate.avatar.remoteUrl | avatar('men')" v-img-error-user="1" alt="" />
      </div>
      <p class="name">{{candidate.candidateName}}</p>
      <div class="separate-info-list">
        <span v-if="candidate.gender">{{candidate.gender | gender}}</span>
        <span v-if="candidate.birthDate">{{candidate.birthDate | userAge}}岁</span>
        <span v-if="candidate.workYear">{{candidate.workYear}}年</span>
        <span v-if="candidate.cityId">{{candidate.cityId | city}}</span>
        <span v-if="candidate.degreeId">{{candidate.degreeId | degree}}</span>
      </div>
    </div>
    <div class="info-wrap">
      <h2 class="title">联系方式</h2>
      <ul class="list-info clearfix">
        <li v-if="candidate.phone">
          <span class="label">联系电话：</span>
          <p>{{candidate.phone}}</p>
        </li>
        <li v-if="candidate.email">
          <span class="label">联系邮箱：</span>
          <p>{{candidate.email}}</p>
        </li>
      </ul>
    </div>
    <div v-if="attachmentResume" class="no-online-wrap">
      简历为附件简历，请PC端查看
    </div>
    <van-collapse v-else v-model="activeNames">
      <van-collapse-item v-if="eduExps&&eduExps.length" title="教育经历" name="2" class="item-list">
        <education :education="eduExps"></education>
      </van-collapse-item>
      <van-collapse-item v-if="workExps&&workExps.length" title="工作经历" name="3" class="item-list">
        <work-experience :work="workExps"></work-experience>
      </van-collapse-item>
      <van-collapse-item v-if="projectExps&&projectExps.length" title="项目经验" name="4" class="item-list">
        <project-experience :project="projectExps"></project-experience>
      </van-collapse-item>
      <van-collapse-item v-if="trainExps&&trainExps.length" title="培训经历" name="5" class="item-list">
        <train-experience :train="trainExps"></train-experience>
      </van-collapse-item>
      <van-collapse-item v-if="languageExps&&languageExps.length" title="语言能力" name="6" class="item-list">
        <language :language="languageExps"></language>
      </van-collapse-item>
      <van-collapse-item v-if="certificateExps&&certificateExps.length" title="证书信息" name="7" class="item-list">
        <certificate :certificate="certificateExps"></certificate>
      </van-collapse-item>
      <van-collapse-item v-if="selfEvaluation" title="自我评价" name="8" class="item-list">
        <p class="text" v-html="selfEvaluation"></p>
      </van-collapse-item>
      <van-collapse-item v-if="extraMsg" title="附加信息" name="9" class="item-list">
        <p class="text" v-html="extraMsg"></p>
      </van-collapse-item>
      <van-collapse-item v-if="(attachments&&attachments.length || worksLinks&&worksLinks.length)" title="我的作品" name="10" class="item-list">
        <div class="text">
          <p v-for="(attach, index) in attachments" :key="index">作品附件： {{attach.attachmentName}}</p>
          <p v-for="(link, index) in worksLinks" :key="index">作品地址： {{link.attachmentPath}}</p>
        </div>
      </van-collapse-item>
    </van-collapse>
    <div class="btn-wrap">
      <van-button type="default" @click="showTalent = true" class="btn-def">联系候选人</van-button>
    </div>
    <!--联系候选人弹出层-->
    <van-popup v-model="showTalent" position="bottom" class="pop-up-talent">
      <pop-talent :talent="candidate" @close="showTalent=false"></pop-talent>
    </van-popup>
  </div>
</template>
<style scoped lang="scss">
.resume-candidate-detail {
  background-color: #f5f5f5;
  padding-bottom: 74px;
}
.no-online-wrap {
  padding: 30px 0;
  text-align: center;
  font-size: 16px;
  background: #fff;
}
.top-banner {
  width: 100%;
  position: relative;
  height: 185px;
  background-image: url("./img/talent-bg.png");
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  color: #fff;
  .img-wrap {
    display: block;
    margin-top: 20px;
    margin-right: 0;
    width: 75px;
    height: 75px;
    line-height: 73px;
  }
  .name {
    font-size: 16px;
    margin: 12px 0;
  }
  .separate-info-list {
    color: #fff;
    font-size: 13px;
  }
}
.list-info {
  line-height: 20px;
  padding-bottom: 5px;
  li {
    margin-bottom: 10px;
    font-size: 14px;
    float: left;
    width: 100%;
    .label {
      width: 70px;
      color: #666;
      display: block;
      float: left;
    }
    p {
      color: #151515;
      margin-left: 70px;
      white-space: pre-line;
    }
  }
}
.info-wrap {
  margin-bottom: 10px;
  background: #fff;
  h2.title {
    font-size: 16px;
    color: #333;
    border-bottom: solid 0.5px #e5e5e5;
    margin: 0 0 0 15px;
    padding-right: 15px;
    height: 45px;
    line-height: 45px;
    position: relative;
    .icon-arrow {
      position: absolute;
      right: 0;
      top: 15px;
    }
  }
  h2.no-border {
    border: 0;
  }
  .list-info {
    padding: 16px;
  }
}
.item-list {
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0;
  }
}
.btn-wrap {
  position: fixed;
  z-index: 99;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 10px 0;
  background-color: #fafafa;
  justify-content: space-around;
  .btn-def,
  .btn-pri {
    font-size: 16px;
    border-radius: 4px;
    flex-grow: 1;
  }
  .btn-def {
    margin: 0 15px;
    border-color: #22baa5;
    color: #22baa5;
  }
}
</style>
<style lang="scss">
.resume-candidate-detail {
  .van-cell__title {
    font-size: 16px;
  }
  .van-collapse-item__content {
    padding: 15px 15px 0;
  }
  .progress-content {
    overflow: hidden;
    > ul {
      background-color: #fff;
      padding: 0 0 0 7px;
      > li {
        position: relative;
        padding: 6px 0 20px 15px;
        line-height: 24px;
        color: #333;
        font-size: 14px;
        em {
          position: absolute;
          width: 1px;
          height: 100%;
          background: #ddd;
          top: 8px;
          left: 0;
        }
        &:first-child {
          em {
            top: 8px;
          }
        }
        &:last-child {
          border-left: none;
        }
        > i {
          left: -6px;
          position: absolute;
          background: url("../../assets/blue-line-dot.png") center center
            no-repeat;
          width: 13px;
          height: 13px;
          display: inline-block;
          top: 6px;
          background-size: cover;
        }
        .img-wrap {
          float: left;
        }
        .info-box {
          margin-left: 55px;
          p {
            font-size: 14px;
            color: #333;
            margin-bottom: 10px;
            line-height: 20px;
            white-space: pre-line;
          }
          p.remark {
            color: #666;
            font-size: 12px;
          }
          p.gray {
            color: #666;
          }
          .separate-info-list {
            color: #333;
            font-size: 14px;
            width: 100%;
            display: block;
            > span {
              white-space: pre-line;
            }
          }
        }
        .inner-list-info {
          line-height: 20px;
          li {
            margin-bottom: 8px;
            font-size: 12px;
            .label {
              width: 56px;
              color: #999;
              display: block;
              float: left;
            }
            p {
              color: #666;
              margin-left: 56px;
              white-space: pre-line;
            }
          }
        }
      }
    }
  }
  .text {
    font-size: 14px;
    color: #333333;
    line-height: 25px;
    padding-bottom: 15px;
    white-space: pre-line;
  }
}
</style>
<script>
import Education from "@/components/resume/education";
import workExperience from "@/components/resume/workExperience";
import projectExperience from "@/components/resume/projectExperience";
import trainExperience from "@/components/resume/trainExperience";
import Language from "@/components/resume/language";
import Certificate from "@/components/resume/certificate";
import popTalent from "@/components/popTalent";
import { handleExperiences } from "@/common/utils";
import { getCandidateDetail } from "@/api/order";
export default {
  name: "resume-candidate-detail-module",
  props: {},
  data() {
    return {
      activeNames: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
      showTalent: false,
      id: this.$route.params.id,
      candidate: null,
      workExps: [],
      eduExps: [],
      projectExps: [],
      trainExps: [],
      languageExps: [],
      certificateExps: [],
      selfEvaluation: "",
      extraMsg: "",
      attachments: [],
      worksLinks: [],
      attachmentResume: null //附件简历
    };
  },
  components: {
    Education,
    workExperience,
    projectExperience,
    trainExperience,
    Language,
    Certificate,
    popTalent
  },
  methods: {
    init() {
      this.getDetail();
    },
    getDetail() {
      getCandidateDetail(this.id)
        .then(res => {
          if (res && res.data) {
            this.candidate = res.data;
            this.attachmentResume = this.candidate.resumeDetail
              ? this.candidate.resumeDetail
              : null;
            //如果不是附件简历，则转换在线简历的数据
            if (!this.attachmentResume) {
              this.convertData(this.candidate);
            }
          } else {
            this.candidate = null;
          }
        })
        .catch(err => {});
    },
    convertData(data) {
      if (data.talentResumeDetailExpModel) {
        let eduExps = data.talentResumeDetailExpModel.eduExps || [];
        let workExps = data.talentResumeDetailExpModel.workExps || [];
        let projectExps = data.talentResumeDetailExpModel.projectExps || [];
        let trainExps = data.talentResumeDetailExpModel.trainExps || [];
        let languageExps =
          data.talentResumeDetailExpModel.languageAbilities || [];
        let certificateExps =
          data.talentResumeDetailExpModel.certifications || [];

        eduExps = handleExperiences(eduExps, "education");
        workExps = handleExperiences(workExps, "work");
        projectExps = handleExperiences(projectExps, "project");
        trainExps = handleExperiences(trainExps, "train");
        certificateExps = handleExperiences(certificateExps, "certificate");

        this.eduExps = eduExps;
        this.workExps = workExps;
        this.projectExps = projectExps;
        this.trainExps = trainExps;
        this.languageExps = languageExps;
        this.certificateExps = certificateExps;
      }

      this.selfEvaluation = data.selfEvaluation || "";
      this.extraMsg = data.extraMsg || "";

      let talentAttachments = data.attachments || [];
      talentAttachments.forEach(work => {
        if (!/^http/.test(work.attachmentPath)) {
          this.attachments.push(work);
        } else {
          this.worksLinks.push(work);
        }
      });
    }
  },
  created() {
    this.init();
  }
};
</script> 
